// extracted by mini-css-extract-plugin
export default {"popover":"elements_popover__UYeZW"};